import { useState, useRef } from 'react'

import { closeModal } from './useModal'
import { apiService } from 'lib/services/api'
import { serializeFormData } from 'lib/utils/form'
import type { ApiError } from 'lib/types/api'
import type { FormErrors, ResetPasswordFormData } from 'lib/types/forms'

export const useResetPasswordForm = () => {
  const formRef = useRef<HTMLFormElement>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [errors, setErrors] = useState<FormErrors>({})

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (!formRef.current || isSubmitting) return

    setErrors({})
    setIsSubmitting(true)

    try {
      const formData = serializeFormData<ResetPasswordFormData>(formRef.current)
      await apiService.resetPassword(formData)

      if (formRef.current) formRef.current.reset()
      closeModal()
    } catch (error) {
      const apiError = error as ApiError
      setErrors(apiError)
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    formRef,
    isSubmitting,
    errors,
    handleSubmit,
  }
}
